<template>
  <div v-if="entry" class="blog-list-entry--wrap flex-grow-1 d-flex flex-column">
    <v-hover>
      <template #default="{ isHovering, props }">
        <v-card
          v-bind="props"
          rounded="lg"
          :elevation="isHovering ? 4 : 0"
          class="is--effect-card flex-grow-1 d-flex flex-column"
        >
          <cms-image
            :image-data="entry.image"
            :alt-fallback="entry.title"
            width="100%"
            height="270px"
            cover
            class="rounded-lg overflow-hidden"
          />
          <v-card-subtitle class="mt-4 mb-n2">
            <template v-if="entry.date">
              {{ readableDate(entry.date) }}
            </template>
          </v-card-subtitle>

          <v-card-title>
            <span class="animated-gradient-text">
              {{ entry.title }}
            </span>
          </v-card-title>

          <v-card-text>
            {{ entry.teaser }}
          </v-card-text>

          <v-card-actions class="px-4 pb-4">
            <v-btn
              variant="outlined"
              size="small"
              rounded="sm"
              @click="$emit('show:details', entry)"
            >
              Mehr erfahren
            </v-btn>

            <v-spacer />

            <div>
              <v-chip
                v-for="tag in entry.tags"
                :key="`${entry.id}_${tag.id}`"
                :color="tag.color"
                rounded="xl"
                variant="elevated"
                elevation="0"
                size="small"
                class="ml-2"
              >
                {{ tag.label }}
              </v-chip>
            </div>
          </v-card-actions>
        </v-card>
      </template>
    </v-hover>
  </div>
</template>

<script>
export default {
  name: 'blog-list-entry',

  props: {
    entry: {
      type: Object,
      required: true,
    },
  },

  emits: [
    'show:details',
  ],
}
</script>
